import styled, { css } from 'styled-components';

import { ow, tint } from 'containers/Overwatch/theme/tokens';

import { orbitRole, orbitTokens, orbitType } from '../../styles';

// Colours from orbit-full-page-spec.md, taken from the Orbit and Overwatch palettes where they
// carry the same hex.
export const pg = {
  page: orbitTokens.surfaceConsole,
  rail: orbitTokens.surface,
  card: orbitTokens.surfaceAlt,
  border: orbitTokens.border,
  text: orbitTokens.text,
  secondary: orbitTokens.textSecondary,
  muted: ow.textMuted,
  link: orbitTokens.action,
  primary: orbitTokens.launcherBadge,
  violet: orbitTokens.accent,
  placeholder: orbitTokens.placeholder,
  iconTileStroke: '#2A405F',
  warning: ow.warning,
  success: ow.success,
  danger: ow.danger
} as const;

/**
 * The page reads one step up the Orbit scale from the panel roles of the same name (user,
 * 2026-10-15); hero and title use the page roles drawn at 34 and 22.
 */
export const pageType = {
  hero: orbitType.pageHero,
  pageTitle: orbitType.pageTitle,
  // The composer keeps the panel's 14 input (6410:9295 draws its placeholder at 14).
  composer: orbitType.conversation,
  // Figma 6265:4312 draws "Orbit" at 19; the nearest step at or above it is 20.
  helping: orbitRole('body3'),
  containerBody: orbitRole('body2'),
  conflictBody: orbitRole('body1'),
  conversation: orbitRole('heading5'),
  action: orbitRole('heading5'),
  containerTitle: orbitRole('heading5'),
  drawerTitle: orbitRole('heading5')
};

export const type = (role: keyof typeof pageType, weight: 400 | 600 | 700 | 800 = 400) => css`
  ${pageType[role]}
  font-weight: ${weight};
`;

export const noop = (): void => undefined;

export const PlainButton = styled.button`
  padding: 0;
  border: none;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
`;

export { tint };
